// extracted by mini-css-extract-plugin
var _1 = "UserSearch__bao--kBm_w";
var _2 = "UserSearch__search--l7137";
var _3 = "UserSearch__searchIcon--i_VVd UserSearch__bao--kBm_w";
var _4 = "UserSearch__smallContainer--HTsqD";
export { _1 as "bao", _2 as "search", _3 as "searchIcon", _4 as "smallContainer" }
